import { gql } from "@apollo/client";

export const EMAIL_EXPIRE = gql`
  mutation emailExpire($id: Int!) {
    emailExpire(id: $id) {
      id
      message
      isError
    }
  }
`;
